import React from 'react';

export const PageTitleContext = React.createContext({
    title: '',
    setTitle: () => {
    }
});
